import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { TenantBranding } from '@cwr/shared';
import apiClient from '@/api/client';

export const useTenantStore = defineStore('tenant', () => {
  const branding = ref<TenantBranding | null>(null);
  const loading = ref(false);
  const error = ref<string | null>(null);

  async function fetchBranding() {
    loading.value = true;
    error.value = null;

    try {
      const response = await apiClient.get<TenantBranding>('/tenant/branding');
      branding.value = response.data;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Failed to load tenant branding';
      error.value = message;
      branding.value = null;
    } finally {
      loading.value = false;
    }
  }

  return {
    branding,
    loading,
    error,
    fetchBranding,
  };
});
